import { NgModule } from '@angular/core';

import { FeaturesModule } from '../../../features/features.module';
import { SharedDependenciesModule } from '../../../shared';
import { InstallationMigrationConfirmationModalComponent } from './installation-migration-confirmation-modal/installation-migration-confirmation-modal.component';
import { InstallationMigrationCustomerDevicesModalComponent } from './installation-migration-customer-devices-modal/installation-migration-customer-devices-modal.component';
import { InstallationMigrationCustomerIdsModalComponent } from './installation-migration-customer-ids-modal/installation-migration-customer-ids-modal.component';
import { InstallationMigrationErrorModalComponent } from './installation-migration-error-modal/installation-migration-error-modal.component';
import { InstallationMigrationModalComponent } from './installation-migration-modal/installation-migration-modal.component';

@NgModule({
  imports: [SharedDependenciesModule, FeaturesModule],
  declarations: [
    InstallationMigrationCustomerIdsModalComponent,
    InstallationMigrationCustomerDevicesModalComponent,
    InstallationMigrationConfirmationModalComponent,
    InstallationMigrationErrorModalComponent,
    InstallationMigrationModalComponent,
  ],
})
export class InstallationsMigrationModule {}
